import { BaseClient } from '@/common/services/api/BaseClient'
import { getQueryUrlFromData } from '@/common/utils/transformFilters'

export class AppsApi extends BaseClient {
  getFiltersConfig = (token) => {
    return this.createRequest({
      url: '/api/apps/filters',
      method: 'get',
      ...(token && { token }),
    })()
  }

  getGenres = (value) => {
    return this.createRequest({
      url: `/api/apps/genres/${value}`,
      method: 'get',
    })()
  }

  getApps = (params = {}) => {
    return this.createRequest({
      url: `/api/apps/search`,
      method: 'get',
      params: {
        ...params,
      },
      paramsSerializer: (params) => {
        return getQueryUrlFromData(params)
      },
    })()
  }

  getAppsDetails = async ({ id, token }) => {
    return this.createRequest({
      url: `/api/apps/app/${id}`,
      method: 'get',
      ...(token && { token }),
    })()
  }

  getAppsDetailsStatistics = ({ id }) => {
    return this.createRequest({
      url: `/api/apps/app/${id}/ads-statistic`,
      method: 'get',
    })()
  }

  getDetailsAdsForApps = (id) => {
    return this.createRequest({
      url: `/api/apps/app/${id}/ads`,
      method: 'get',
    })()
  }

  getPublisherApps = (id) => {
    return this.createRequest({
      url: `/api/apps/publisher/${id}`,
      method: 'get',
    })()
  }

  translateApps = (appId, locale, mode) => {
    return this.createRequest({
      url: `/api/apps/app/${appId}/translate?mode=${mode}`,
      method: 'get',
      data: {
        locale,
      },
    })()
  }
}
